// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgTooltipArrow = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={13}
    fill="none"
    viewBox="0 0 30 13"
    ref={ref}
    {...props}
  >
    <path fill="currentColor" d="M19.243 10.757a6 6 0 0 1-8.486 0L0 0h30z" />
  </svg>
);
export const TooltipArrowIcon = forwardRef(SvgTooltipArrow);
